import { render, staticRenderFns } from "./ModalIcon.vue?vue&type=template&id=59f1ceec&scoped=true&"
import script from "./ModalIcon.vue?vue&type=script&lang=js&"
export * from "./ModalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f1ceec",
  null
  
)

export default component.exports